
import { observer } from 'mobx-react-lite'
// evertel
import { Text, Row, IconLink, useUI } from '@evertel/web/ui'
import { HTMLAttributes, useEffect } from 'react'
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'
import { DepartmentController } from '@evertel/department'
import { HeaderButtonSort } from './HeaderButtonSort'
import { HeaderButtonAdd } from './HeaderButtonAdd'
import { HeaderButtonSettings } from './HeaderButtonSettings'
import { CurrentUserController } from '@evertel/blue-user'


interface DrawerHeaderProps extends HTMLAttributes<HTMLDivElement> {
    onClick?: () => void
}


const DrawerHeader: React.FC<DrawerHeaderProps> = observer(({
    ...otherProps
}) => {

    const sessionService = useService(SessionService, [])
    const currentUserController = useService(CurrentUserController, [])
    const departmentController = useService(DepartmentController, [sessionService.selectedDepartmentId])

    const { leftNavOpen, toggleLeftNav } = useUI()

    useEffect(() => {
        (async () => {
            if (!sessionService.selectedDepartmentId) return

            await departmentController.init(sessionService.selectedDepartmentId)

        })()
    }, [departmentController, sessionService.currentUserId, sessionService.selectedDepartmentId])

    return (
        <Row
            align="between"
            className="drawer-header"
            {...otherProps}>
            <Text className="dept-name">
                {departmentController.shortName}
            </Text>
            <Row className="drawer-header-menu">
                <HeaderButtonSort className="ms-2"/>
                <HeaderButtonAdd
                    className="ms-2"
                />
                <HeaderButtonSettings
                    className="ms-2"
                />
                <IconLink
                    className="ms-2 floating-menu-root toggle-drawer-btn"
                    label=""
                    icon={{
                        name: (leftNavOpen) ? 'arrow-alt-from-right' : 'sidebar',
                        size: 16
                    }}
                    onClick={() => toggleLeftNav('toggle')}
                    aria-expanded={leftNavOpen}
                    title="Toggle the Sidebar"
                    aria-label={leftNavOpen ? 'Collapse Room & DM Sidebar' : 'Expand Room & DM Sidebar'}
                />
            </Row>
        </Row>
    )
})

export { DrawerHeader }
